<template>
  <div>
    <Modal v-model="resModal" :mask-closable="false" footer-hide width="60">
      <p slot="header" class="text-center">选择资源</p>
      <div class="m-b-10 text-orange">提示：只允许选择一个资源。</div>
      <div>
        <Row :gutter="8" class="m-b-5">
          <i-col span="3">
            <Select
              v-model="resQuery.assetId"
              :cleable="false"
              size="small"
              placeholder="选择资产"
              @on-change="handleChangeAsset"
            >
              <Option
                v-for="item in assetArray"
                :key="'aid_' + item.id"
                :value="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </i-col>
          <i-col span="3">
            <i-select
              size="small"
              placeholder="站点（可搜索）"
              clearable
              filterable
              v-model="resQuery.stationId"
            >
              <i-option
                :value="item.id"
                v-for="item in stationArray"
                :key="item.id"
                >{{ item.name }}</i-option
              >
            </i-select>
          </i-col>
          <i-col span="3">
            <i-select
              size="small"
              placeholder="位置"
              clearable
              v-model="resQuery.position"
            >
              <i-option
                v-for="item in positionArray"
                :value="item.value"
                :key="'pos_' + item.value"
                >{{ item.name }}</i-option
              >
            </i-select>
          </i-col>
          <i-col span="3">
            <i-select
              size="small"
              placeholder="资源类型(可搜索)"
              clearable
              filterable
              v-model="resQuery.resourcetypeId"
            >
              <OptionGroup
                v-for="item in resourceTypeArray"
                :key="'re_parent_' + item.id"
                :label="item.name"
              >
                <Option
                  v-for="child in item.children"
                  :value="child.id"
                  :key="'re_child' + child.id"
                  >{{ child.name }}
                </Option>
              </OptionGroup>
            </i-select>
          </i-col>
          <i-col span="2">
            <i-select
              size="small"
              placeholder="等级"
              clearable
              v-model="resQuery.level"
            >
              <i-option
                v-for="item in levelArray"
                :key="'level_' + item.id"
                :value="item.id"
                >{{ item.name }}</i-option
              >
            </i-select>
          </i-col>
          <i-col span="2">
            <i-select
              size="small"
              placeholder="状态"
              clearable
              v-model="resQuery.enabled"
            >
              <i-option
                v-for="item in statusArray"
                :key="'status_' + item.value"
                :value="item.value"
                >{{ item.name }}</i-option
              >
            </i-select>
          </i-col>

          <i-col span="4">
            <i-input
              size="small"
              placeholder="关键字：支持名称查询"
              v-model="resQuery.keyword"
            ></i-input>
          </i-col>
          <i-col span="4">
            <i-button
              size="small"
              class="m-r-5"
              type="primary"
              icon="ios-search"
              @click="handleSearch"
              >搜索</i-button
            >
          </i-col>
        </Row>
        <Table
          size="small"
          stripe
          :max-height="700"
          :data="resList"
          :columns="resColumns"
          :loading="resLoading"
        >
        </Table>
        <div class="paging_style">
          <Page
            size="small"
            :total="resTotal"
            :page-size="resQuery.pageSize"
            show-total
            show-elevator
            show-sizer
            :current="resQuery.pageNumber"
            :page-size-opts="[15, 50, 100, 200]"
            @on-change="handlePageChange"
            @on-page-size-change="handelChangePageSize"
          ></Page>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getPositions, getResourcePage } from '@/api/product/resource'
import { getResourceTypeList } from '@/api/product/asset'
import { getStationByAsset } from '@/api/product/station'
export default {
  // props: {
  //   assetIds: {
  //     type: Array,
  //     required: true
  //   },
  //   skuId: {
  //     type: Number,
  //     required: true
  //   },
  //   projectId: {
  //     type: Number,
  //     required: true
  //   }
  // },
  computed: {
    assetArray () {
      return this.$store.state.productManage.assetArray
    }
    // opType () {
    //   return this.$store.state.productManage.opType
    // }
  },
  data () {
    return {
      resModal: false,
      resLoading: false,
      resQuery: {
        pageSize: 15,
        pageNumber: 1,
        assetId: null,
        stationId: null,
        enabled: 1,
        position: null,
        level: null,
        resourcetypeId: null,
        keyword: ''
      },
      stationArray: [],
      positionArray: [],
      resourceTypeArray: [],
      levelArray: [
        { id: -2, name: 'B' },
        { id: 1, name: 'A' },
        { id: 2, name: 'A+' },
        { id: 3, name: 'A++' },
        { id: 4, name: 'S' },
        { id: 5, name: 'S+' },
        { id: 6, name: 'S++' },
        { id: 7, name: 'S+++' }
      ],
      statusArray: [
        { value: 1, name: '可用' },
        { value: 0, name: '不可用' }
      ],
      resList: [],
      resTotal: 0,
      resColumns: [
        // { type: 'selection', width: 60, align: 'center' },
        { title: '编号', align: 'center', key: 'code' },
        { title: '所属站点', align: 'center', key: 'stationName' },
        {
          title: '资源类型',
          align: 'center',
          key: 'resourcetypeName',
          render: (h, { row }) => {
            return h('span', `${row.resourceBigtypeName} - ${row.resourcetypeName}`)
          }
        },
        { title: '等级', align: 'center', key: 'levelName' },
        {
          title: '状态',
          align: 'center',
          key: 'enabled',
          render: (h, params) => {
            return h('span', params.row.enabled ? '可用' : '不可用')
          }
        }, {
          title: '操作',
          align: 'center',
          render: (h, { row }) => {
            return h('a', {
              on: {
                click: () => {
                  this.onConfirmChoice(row)
                }
              }
            }, '选择资源')
          }
        }
      ]
    }
  },
  methods: {
    showModal () {
      this.resBoxShow = 'tab_exist'
      this.resQuery.assetId = this.assetArray[0].id
      this.initStationArray()
      this.getPositionData()
      this.getResourceTypeData()
      this.getResData()
      this.resModal = true
    },
    handleChangeAsset () {
      this.initStationArray()
      this.getPositionData()
      this.handleSearch()
    },
    // 初始化站点选项
    initStationArray () {
      this.resQuery.stationId = null
      getStationByAsset({ assetId: this.resQuery.assetId }).then((res) => {
        if (res && !res.errcode) {
          this.stationArray = res
        } else {
          this.stationArray = []
        }
      })
    },
    getPositionData () {
      getPositions({ assetIds: JSON.stringify([this.resQuery.assetId]) }).then(res => {
        if (res && !res.errcode) {
          this.positionArray = res
        } else {
          this.positionArray = []
        }
      })
    },
    /**
    * 获取资源类型数据
    */
    getResourceTypeData () {
      getResourceTypeList({ assetId: this.resQuery.assetId }).then(res => {
        if (res && !res.errcode) {
          this.resourceTypeArray = res
        } else {
          this.resourceTypeArray = []
        }
      })
    },
    getResData () {
      this.resLoading = true
      getResourcePage(this.resQuery).then(res => {
        if (res && !res.errcode) {
          this.resList = res.list
          this.resTotal = res.totalRow
          this.resQuery.pageNumber = res.pageNumber
          // this.resList.forEach(item => {
          //   item._checked = false
          //   if (this.selectedResArray.some(x => x.id === item.id)) {
          //     item._checked = true
          //   }
          // })
        } else {
          this.resList = []
          this.resTotal = 0
          this.resQuery.pageNumber = 1
        }
      }).finally(() => { this.resLoading = false })
    },
    handlePageChange (curPage) {
      this.resQuery.pageNumber = curPage
      this.getResData()
    },
    handelChangePageSize (pageSize) {
      this.resQuery.pageSize = pageSize
      this.getResData()
    },
    handleSearch () {
      this.resQuery.pageNumber = 1
      this.getResData()
    },
    onConfirmChoice (row) {
      this.$emit('onSetRes', row)
      this.resModal = false
      this.$Notice.success({ desc: '资源选择成功' })
    }
  }
}
</script>
